// Generated by ts-to-zod
import { z } from 'zod';

const apiOrdersNoticesSchema = z.object({
  id: z.number(),
  notices: z.string(),
  order_id: z.number().nullable(),
});

const assortmentGroupsSchema = z.object({
  external_id: z.string().nullable(),
  id: z.number(),
  name: z.string(),
});

const assortmentsSchema = z.object({
  assortment_group: z.number().nullable(),
  cargo_type: z.string().nullable(),
  discharging_rate: z.string().nullable(),
  discharging_unit: z.string().nullable(),
  fill_factor: z.string().nullable(),
  id: z.number(),
  loading_rate: z.string().nullable(),
  loading_unit: z.string().nullable(),
  margin_amount: z.string().nullable(),
  margin_unit: z.string().nullable(),
  name: z.string(),
  specific_gravity: z.string().nullable(),
  stowage_factor_max: z.string().nullable(),
  stowage_factor_min: z.string().nullable(),
});

const bunkerGradeOverrideSchema = z.object({
  carbon_factor: z.string().nullable(),
  currency: z.string(),
  grade_name: z.string(),
  id: z.number(),
  price: z.string().nullable(),
  price_adjustment: z.string().nullable(),
  reference_grade: z.string().nullable(),
  reference_port: z.string().nullable(),
});

const cargoCompartmentSchema = z.object({
  id: z.number(),
  max_volume: z.string(),
  name: z.string(),
  ship_id: z.number().nullable(),
  type: z.string().nullable(),
  vessel_id: z.number().nullable(),
  volume_unit: z.string().nullable(),
});

const cargoCompartmentAllocationSchema = z.object({
  amount: z.string(),
  client_id: z.string(),
  compartment_id: z.number(),
  id: z.number(),
  order_id: z.number(),
  scheduled_order_client_id: z.string(),
});

const cargoExclusionSchema = z.object({
  assortment: z.number().nullable(),
  assortment_group: z.number().nullable(),
  distance: z.string().nullable(),
  id: z.number(),
  order_id: z.number(),
  tanks: z.number().nullable(),
  voyages: z.number().nullable(),
});

const cargoUnitsSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
});

const channelCostEstimatesSchema = z.object({
  assortment_group_id: z.number().nullable(),
  cargo_condition: z.string().nullable(),
  channel_cost: z.string(),
  channel_cost_currency: z.string(),
  channel_name: z.string(),
  duration_overhead: z.string().nullable(),
  id: z.number(),
  vessel_id: z.number().nullable(),
  vessel_type_id: z.number().nullable(),
});

const channelIncompatibilitiesSchema = z.object({
  channel_name: z.string(),
  id: z.number(),
  vessel_attribute_id: z.number(),
});

const coaContractAssortmentsSchema = z.object({
  assortment_group_id: z.number().nullable(),
  assortment_id: z.number().nullable(),
  coa_contract_id: z.number(),
  id: z.number(),
  max_amount: z.string().nullable(),
  min_amount: z.string().nullable(),
  payment_unit: z.string(),
});

const coaContractBunkerSchema = z.object({
  baf_bunker_amount: z.string().nullable(),
  baf_start_from_base: z.boolean().nullable(),
  baf_step_effect: z.string().nullable(),
  baf_step_size: z.string().nullable(),
  baf_type: z.string().nullable(),
  baf_use_step_effect_as_value: z.boolean().nullable(),
  base_price_max: z.string().nullable(),
  bunker_grade: z.string(),
  coa_assortment_id: z.number().nullable(),
  coa_contract_id: z.number(),
  coa_route_id: z.number().nullable(),
  id: z.number(),
  price: z.string(),
});

const coaContractPortDataSchema = z.object({
  coa_contract_id: z.number(),
  id: z.number(),
  port_data_id: z.number(),
});

const coaContractPortsSchema = z.object({
  coa_contract_id: z.number(),
  destination_id: z.number().nullable(),
  destination_zone_id: z.number().nullable(),
  id: z.number(),
  origin_id: z.number().nullable(),
  origin_zone_id: z.number().nullable(),
});

const coaContractPricesSchema = z.object({
  coa_assortment_id: z.number(),
  coa_contract_id: z.number(),
  id: z.number(),
  price: z.string(),
  route_id: z.number().nullable(),
});

const coaContractShipsSchema = z.object({
  coa_contract_id: z.number(),
  id: z.number(),
  ship_id: z.number(),
});

const coaContractsSchema = z.object({
  amount_unit_id: z.number().nullable(),
  charterer_org_id: z.number(),
  currency: z.string().nullable(),
  end_date: z.string(),
  id: z.number(),
  inactive: z.boolean(),
  max_amount: z.string().nullable(),
  min_amount: z.string().nullable(),
  name: z.string().nullable(),
  shipowner_org_id: z.number(),
  start_date: z.string(),
});

const commissionSchema = z.object({
  assortment_id: z.number().nullable(),
  baf_applied: z.boolean().nullable(),
  demurrage_applied: z.boolean().nullable(),
  discharge_port_id: z.number().nullable(),
  extra_freight_applied: z.boolean().nullable(),
  id: z.number(),
  load_port_id: z.number().nullable(),
  organization_id: z.number().nullable(),
  type: z.string(),
  value: z.string(),
  voyage_charter_id: z.number().nullable(),
});

const commitLogSchema = z.object({
  committed_at: z.string(),
  committed_by: z.number().nullable(),
  id: z.number(),
  master_client_id: z.string().nullable(),
  scenario_client_id: z.string().nullable(),
});

const commitLogScenariosSchema = z.object({
  client_id: z.string(),
  id: z.number(),
});

const filesSchema = z.object({
  id: z.number(),
  note: z.string().nullable(),
  type: z.string(),
});

const handledByCoaSchema = z.object({
  client_id: z.string(),
  coa_id: z.number(),
  discharging_concurrent: z.boolean(),
  discharging_duration: z.string(),
  discharging_duration_override: z.string().nullable(),
  discharging_end: z.string(),
  discharging_sea_duration_override: z.string().nullable(),
  discharging_start: z.string(),
  discharging_start_override: z.string().nullable(),
  id: z.number(),
  loading_concurrent: z.boolean(),
  loading_duration: z.string(),
  loading_duration_override: z.string().nullable(),
  loading_end: z.string(),
  loading_sea_duration_override: z.string().nullable(),
  loading_start: z.string(),
  loading_start_override: z.string().nullable(),
  metadata: z.string().nullable(),
  order_id: z.number(),
  shared: z.boolean(),
  updated_at: z.string().nullable(),
  vessel_id: z.number().nullable(),
});

const handledBySpotSchema = z.object({
  client_id: z.string(),
  discharging_concurrent: z.boolean(),
  discharging_duration: z.string(),
  discharging_duration_override: z.string().nullable(),
  discharging_end: z.string(),
  discharging_sea_duration_override: z.string().nullable(),
  discharging_start: z.string(),
  discharging_start_override: z.string().nullable(),
  id: z.number(),
  loading_concurrent: z.boolean(),
  loading_duration: z.string(),
  loading_duration_override: z.string().nullable(),
  loading_end: z.string(),
  loading_sea_duration_override: z.string().nullable(),
  loading_start: z.string(),
  loading_start_override: z.string().nullable(),
  metadata: z.string().nullable(),
  order_id: z.number().nullable(),
  owner_organisation_id: z.number().nullable(),
  shared: z.boolean(),
  updated_at: z.string().nullable(),
  vessel_id: z.number().nullable(),
});

const latestPortCostByPortAndPrimaryAttributeSchema = z.object({
  port_cost: z.string().nullable(),
  port_cost_currency: z.string().nullable(),
  port_name: z.string().nullable(),
  primary_attribute_id: z.number().nullable(),
});

const offHireSchema = z.object({
  archived: z.boolean(),
  ballast_bonus: z.string().nullable(),
  ballast_bonus_commissionable: z.boolean().nullable(),
  client_id: z.string(),
  commission_pct: z.string().nullable(),
  duration: z.string(),
  end: z.string(),
  id: z.number(),
  location_a_id: z.number(),
  location_b_id: z.number(),
  locked: z.boolean(),
  meta: z.string().nullable(),
  planning_organisation_id: z.number(),
  shared: z.boolean(),
  start: z.string(),
  tc_out_rate: z.string().nullable(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
  user_id: z.number(),
  vessel_id: z.number().nullable(),
});

const orderAttributeAssociationsSchema = z.object({
  id: z.number(),
  order_attribute_id: z.number(),
  order_id: z.number(),
});

const orderDetailsSchema = z.object({
  cargo_deck_option: z.string().nullable(),
  cargo_max_unit_weight: z.string().nullable(),
  closing_date: z.string().nullable(),
  consignee: z.string().nullable(),
  external_remarks: z.string().nullable(),
  extra_info: z.string().nullable(),
  fixture_note: z.string().nullable(),
  id: z.number(),
  imo_class: z.string().nullable(),
  inco_terms: z.string().nullable(),
  order_id: z.number(),
  order_name: z.string().nullable(),
  receiver_organisation_id: z.number().nullable(),
  sender_organisation_id: z.number().nullable(),
  supply_contract_id: z.number().nullable(),
});

const orderPortCallRelationSchema = z.object({
  id: z.number(),
  is_load_port: z.boolean(),
  order_id: z.number(),
  port_call_id: z.number(),
});

const orderRequirementAssociationSchema = z.object({
  id: z.number(),
  order_id: z.number(),
  special_requirement_id: z.number(),
});

const orderVoyageCharterRelationSchema = z.object({
  coa_route_id: z.number().nullable(),
  id: z.number(),
  order_id: z.number(),
  outgoing: z.boolean(),
  voyage_charter_id: z.number(),
});

const ordersSchema = z.object({
  archived: z.boolean(),
  assortment_id: z.number().nullable(),
  cancelling: z.string().nullable(),
  cargo_amount: z.string(),
  cargo_unit_id: z.number().nullable(),
  charterer_organization_id: z.number().nullable(),
  coa_id: z.number().nullable(),
  completed: z.string().nullable(),
  created_at: z.string().nullable(),
  delivered_before: z.string().nullable(),
  discharge_port_id: z.number(),
  discharging_overhead_duration: z.string().nullable(),
  discharging_rate: z.string().nullable(),
  discharging_unit: z.string().nullable(),
  external_order_id: z.string().nullable(),
  id: z.number(),
  layday: z.string().nullable(),
  load_port_id: z.number().nullable(),
  loading_overhead_duration: z.string().nullable(),
  loading_rate: z.string().nullable(),
  loading_unit: z.string().nullable(),
  margin_amount: z.string().nullable(),
  margin_unit: z.string().nullable(),
  min_vessel_class_requirement: z.number().nullable(),
  nominated_vessel: z.string().nullable(),
  rta: z.string().nullable(),
  shipment_id: z.number().nullable(),
  specific_gravity: z.string().nullable(),
  started: z.string().nullable(),
  stowage_factor_max: z.string().nullable(),
  stowage_factor_min: z.string().nullable(),
  to_be_deleted: z.boolean().nullable(),
  user_id: z.number().nullable(),
});

const organizationsSchema = z.object({
  broker: z.boolean(),
  config_auto_accept_only_confirmed: z.boolean(),
  config_cargo_allocation_combine_assortment: z.boolean(),
  config_enable_accept_all_updates: z.boolean(),
  config_enable_scenario_auto_save: z.boolean(),
  config_events_concurrent_default: z.boolean(),
  config_portcall_duration_berthapi_default: z.boolean(),
  draft: z.string().nullable(),
  id: z.number(),
  name: z.string().nullable(),
  port_cost_priority: z.string().nullable(),
});

const portActivitySchema = z.object({
  end: z.string().nullable(),
  id: z.number(),
  operation: z.string().nullable(),
  start: z.string(),
  statement_of_facts_id: z.number(),
});

const portCallSchema = z.object({
  archived: z.boolean(),
  bunker_overrides: z.string().nullable(),
  bunker_price_source: z.string().nullable(),
  channel_cost_default_id: z.number().nullable(),
  channel_duration_overhead: z.string().nullable(),
  client_id: z.string(),
  id: z.number(),
  leg_avoids_channels: z.boolean(),
  location_id: z.number(),
  one_time_override_channel_cost: z.string().nullable(),
  one_time_override_cost: z.string().nullable(),
  planned_arrival: z.string().nullable(),
  planned_arrival_duration: z.string().nullable(),
  planned_arrival_override: z.string().nullable(),
  planned_arrival_override_sourced_at: z.string().nullable(),
  planned_arrival_override_sourced_from: z.string().nullable(),
  planned_berthing: z.string().nullable(),
  planned_berthing_duration: z.string().nullable(),
  planned_berthing_override: z.string().nullable(),
  planned_berthing_override_sourced_at: z.string().nullable(),
  planned_berthing_override_sourced_from: z.string().nullable(),
  planned_departure: z.string().nullable(),
  planned_departure_duration: z.string().nullable(),
  planned_departure_override: z.string().nullable(),
  planned_departure_override_sourced_at: z.string().nullable(),
  planned_departure_override_sourced_from: z.string().nullable(),
  port_cost_default_id: z.number().nullable(),
  previous_location_id: z.number().nullable(),
  sea_duration_override: z.string().nullable(),
  total_discharge_duration_override: z.string().nullable(),
  total_load_duration_override: z.string().nullable(),
  updated_at: z.string().nullable(),
  use_historical_port_cost: z.boolean(),
  use_integration_port_cost: z.boolean(),
  use_latest_historical_port_cost: z.boolean(),
  use_one_time_override_cost: z.boolean(),
  vessel_id: z.number().nullable(),
  weather_factor: z.string().nullable(),
});

const portCallFilesSchema = z.object({
  file_id: z.number(),
  id: z.number(),
  port_call_id: z.number(),
});

const portCostDefaultSchema = z.object({
  cost: z.string(),
  currency: z.string(),
  id: z.number(),
  location_id: z.number(),
  vessel_id: z.number().nullable(),
  vessel_type_id: z.number().nullable(),
});

const portCostsByPortAndPrimaryAttributeSchema = z.object({
  avg: z.string().nullable(),
  count: z.number().nullable(),
  max: z.string().nullable(),
  median: z.number().nullable(),
  min: z.string().nullable(),
  port_cost_currency: z.string().nullable(),
  port_name: z.string().nullable(),
  primary_attribute_id: z.number().nullable(),
});

const portCostsByPortAndVesselNameSchema = z.object({
  avg: z.string().nullable(),
  count: z.number().nullable(),
  max: z.string().nullable(),
  median: z.number().nullable(),
  min: z.string().nullable(),
  port_cost_currency: z.string().nullable(),
  port_name: z.string().nullable(),
  vessel_name: z.string().nullable(),
});

const portDataSchema = z.object({
  discharge_rate: z.string().nullable(),
  id: z.number(),
  laytime_days: z.string().nullable(),
  loading_discharge_unit: z.string().nullable(),
  loading_rate: z.string().nullable(),
  port_id: z.number(),
});

const portNoticeSchema = z.object({
  ata_berth: z.string().nullable(),
  ata_pbp: z.string().nullable(),
  berthing_prospects: z.string().nullable(),
  eta: z.string().nullable(),
  etd_berth: z.string().nullable(),
  id: z.number(),
  nor_tendered: z.string().nullable(),
  port_call_id: z.number(),
});

const scheduledOrderSchema = z.object({
  cleaning_omitted: z.boolean(),
  client_id: z.string(),
  created_by_user_id: z.number().nullable(),
  discharging_concurrent: z.boolean(),
  discharging_duration: z.string(),
  discharging_duration_override: z.string().nullable(),
  discharging_end: z.string(),
  discharging_sea_duration_override: z.string().nullable(),
  discharging_start: z.string(),
  discharging_start_override: z.string().nullable(),
  id: z.number(),
  loading_concurrent: z.boolean(),
  loading_duration: z.string(),
  loading_duration_override: z.string().nullable(),
  loading_end: z.string(),
  loading_sea_duration_override: z.string().nullable(),
  loading_start: z.string(),
  loading_start_override: z.string().nullable(),
  order_id: z.number(),
  shared: z.boolean(),
  updated_at: z.string().nullable(),
  vessel_id: z.number().nullable(),
});

const shipVoyageNamingRuleRelationSchema = z.object({
  id: z.number(),
  rule_id: z.number(),
  ship_id: z.number(),
});

const shipmentSchema = z.object({
  client_id: z.string(),
  external_shipment_id: z.string().nullable(),
  id: z.number(),
  name: z.string(),
  remarks: z.string().nullable(),
  voyage_attribute_id: z.number().nullable(),
});

const shipmentExternalStatusSchema = z.object({
  id: z.number(),
  shipment_id: z.number(),
  status: z.string(),
});

const shipmentExtraFreightSchema = z.object({
  client_id: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  freight_amount: z.string(),
  freight_unit: z.string(),
  id: z.number(),
  name: z.string().nullable(),
  shipment_id: z.number(),
  updated_at: z.string().nullable(),
});

const shipmentFreightSchema = z.object({
  client_id: z.string(),
  freight_amount: z.string(),
  freight_unit: z.string(),
  id: z.number(),
  shipment_id: z.number(),
});

const shipsSchema = z.object({
  breadth: z.string().nullable(),
  crane_capacity: z.string().nullable(),
  csi_score: z.string().nullable(),
  deck_volume_capacity: z.string().nullable(),
  default_bunker_grade_id: z.number().nullable(),
  discharging_rate: z.string().nullable(),
  discharging_unit: z.string().nullable(),
  draft: z.string().nullable(),
  esi_score: z.string().nullable(),
  external_fleet: z.boolean().nullable(),
  gross_tonnage: z.string().nullable(),
  id: z.number(),
  imo: z.string().nullable(),
  inactive: z.boolean(),
  loa: z.string().nullable(),
  loading_rate: z.string().nullable(),
  loading_unit: z.string().nullable(),
  main_engine_capacity: z.string().nullable(),
  mass_capacity: z.string().nullable(),
  mass_unit: z.string().nullable(),
  name: z.string().nullable(),
  net_tonnage: z.string().nullable(),
  organization_id: z.number().nullable(),
  primary_attribute_id: z.number().nullable(),
  remarks: z.string().nullable(),
  short_name: z.string().nullable(),
  sort_id: z.string().nullable(),
  tc_rate: z.string().nullable(),
  vessel_info_id: z.number().nullable(),
  volume_capacity: z.string().nullable(),
  volume_unit: z.string().nullable(),
  weight_capacity: z.number().nullable(),
  weight_capacity_type: z.string().nullable(),
});

const singleEventSchema = z.object({
  archived: z.boolean(),
  cleaning_assortment_exclusion_id: z.number().nullable(),
  client_id: z.string(),
  concurrent: z.boolean(),
  duration: z.string(),
  end: z.string(),
  id: z.number(),
  location_id: z.number(),
  locked: z.boolean(),
  meta: z.string().nullable(),
  sea_duration_override: z.string().nullable(),
  shared: z.boolean(),
  start: z.string(),
  start_override: z.string().nullable(),
  type: z.string(),
  updated_at: z.string().nullable(),
  vessel_id: z.number().nullable(),
});

const singleEventPortCallRelationSchema = z.object({
  id: z.number(),
  port_call_id: z.number(),
  single_event_id: z.number(),
});

const statementOfFactsSchema = z.object({
  arrival_time: z.string().nullable(),
  berthed: z.string().nullable(),
  id: z.number(),
  loading_commenced: z.string().nullable(),
  loading_completed: z.string().nullable(),
  notice_of_readiness: z.string().nullable(),
  pilot_onboard: z.string().nullable(),
  port_call_id: z.number(),
  sailing_time: z.string().nullable(),
});

const tcContractSchema = z.object({
  delivery_end_date: z.string(),
  delivery_port_id: z.number(),
  delivery_start_date: z.string(),
  external_id: z.string(),
  id: z.number(),
  redelivery_end_date: z.string(),
  redelivery_port_id: z.number(),
  redelivery_start_date: z.string(),
  vessel_id: z.number(),
});

const usersSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
});

const vesselAttributesSchema = z.object({
  cargo_compatibility_ranking: z.number().nullable(),
  id: z.number(),
  is_vessel_class: z.boolean(),
  name: z.string(),
});

const vesselAttributesAssociationsSchema = z.object({
  id: z.number(),
  ship_id: z.number(),
  vessel_attribute_id: z.number(),
});

const vesselDraftDatapointsSchema = z.object({
  cargo_load: z.string(),
  draft: z.string(),
  id: z.string(),
  ship_id: z.number(),
});

const vesselFulfillsRequirementAssociationSchema = z.object({
  id: z.number(),
  special_requirement_id: z.number(),
  vessel_attribute_id: z.number().nullable(),
  vessel_id: z.number().nullable(),
});

const vesselInfoSchema = z.object({
  discharging_rate: z.string().nullable(),
  discharging_unit: z.string(),
  id: z.number(),
  loading_rate: z.string().nullable(),
  loading_unit: z.string(),
});

const vesselSpeedConsumptionSchema = z.object({
  area: z.string().nullable(),
  bunker_grade_id: z.number(),
  consumption: z.string(),
  id: z.number(),
  ship_id: z.number(),
  speed: z.string(),
  tag: z.string().nullable(),
  type: z.string(),
});

const voyageCharterSchema = z.object({
  cancelling: z.string().nullable(),
  charterer_org_id: z.number().nullable(),
  currency: z.string().nullable(),
  delete_on_unassign: z.boolean(),
  demurrage: z.string().nullable(),
  external_id: z.string().nullable(),
  id: z.number(),
  is_inquiry: z.boolean(),
  is_preliminary: z.boolean(),
  is_template: z.boolean(),
  layday: z.string().nullable(),
  lumpsum: z.string().nullable(),
  name: z.string().nullable(),
  on_subs_until: z.string().nullable(),
  payment_time: z.number().nullable(),
  payment_trigger: z.string().nullable(),
  payment_type: z.string().nullable(),
  shipowner_org_id: z.number().nullable(),
  vessel_id: z.number().nullable(),
});

const voyageCharterExtraCostSchema = z.object({
  amount: z.string(),
  description: z.string().nullable(),
  id: z.number(),
  name: z.string().nullable(),
  type: z.string().nullable(),
  voyage_charter_id: z.number(),
});

const voyageCharterExtraFreightSchema = z.object({
  amount: z.string(),
  description: z.string().nullable(),
  id: z.number(),
  ignore_in_pnl: z.boolean().nullable(),
  name: z.string().nullable(),
  type: z.string().nullable(),
  voyage_charter_id: z.number(),
});

const voyageCharterOrderFreightSchema = z.object({
  freight_amount: z.string().nullable(),
  freight_unit: z.string().nullable(),
  id: z.number(),
  order_voyage_charter_relation_id: z.number(),
});

const voyageCharterPortDataSchema = z.object({
  id: z.number(),
  port_data_id: z.number(),
  voyage_charter_id: z.number(),
});

const voyageCharterToContractSchema = z.object({
  coa_id: z.number().nullable(),
  id: z.number(),
  voyage_charter_id: z.number(),
});

const voyageNamingRuleSchema = z.object({
  id: z.number(),
  rule: z.string(),
  vessel_fullname: z.boolean().nullable(),
  vessel_imo: z.boolean().nullable(),
  vessel_shortname: z.boolean().nullable(),
  year: z.string(),
  zeros_pad: z.number(),
});

const zoneLocationSchema = z.object({
  id: z.number(),
  location_id: z.number(),
  zone_id: z.number(),
});

const zonesSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const binaryPlanningPageQuerySchema = z.object({
  api_orders_notices: z.array(apiOrdersNoticesSchema),
  assortment_groups: z.array(assortmentGroupsSchema),
  assortments: z.array(assortmentsSchema),
  bunker_grade_override: z.array(bunkerGradeOverrideSchema),
  cargo_compartment: z.array(cargoCompartmentSchema),
  cargo_compartment_allocation: z.array(cargoCompartmentAllocationSchema),
  cargo_exclusion: z.array(cargoExclusionSchema),
  cargo_units: z.array(cargoUnitsSchema),
  channel_cost_estimates: z.array(channelCostEstimatesSchema),
  channel_incompatibilities: z.array(channelIncompatibilitiesSchema),
  coa_contract_assortments: z.array(coaContractAssortmentsSchema),
  coa_contract_bunker: z.array(coaContractBunkerSchema),
  coa_contract_port_data: z.array(coaContractPortDataSchema),
  coa_contract_ports: z.array(coaContractPortsSchema),
  coa_contract_prices: z.array(coaContractPricesSchema),
  coa_contract_ships: z.array(coaContractShipsSchema),
  coa_contracts: z.array(coaContractsSchema),
  commission: z.array(commissionSchema),
  commit_log: z.array(commitLogSchema),
  commit_log_scenarios: z.array(commitLogScenariosSchema),
  files: z.array(filesSchema),
  handled_by_coa: z.array(handledByCoaSchema),
  handled_by_spot: z.array(handledBySpotSchema),
  latest_port_cost_by_port_and_primary_attribute: z.array(
    latestPortCostByPortAndPrimaryAttributeSchema,
  ),
  off_hire: z.array(offHireSchema),
  order_attribute_associations: z.array(orderAttributeAssociationsSchema),
  order_details: z.array(orderDetailsSchema),
  order_port_call_relation: z.array(orderPortCallRelationSchema),
  order_requirement_association: z.array(orderRequirementAssociationSchema),
  order_voyage_charter_relation: z.array(orderVoyageCharterRelationSchema),
  orders: z.array(ordersSchema),
  organizations: z.array(organizationsSchema),
  port_activity: z.array(portActivitySchema),
  port_call: z.array(portCallSchema),
  port_call_files: z.array(portCallFilesSchema),
  port_cost_default: z.array(portCostDefaultSchema),
  port_costs_by_port_and_primary_attribute: z.array(
    portCostsByPortAndPrimaryAttributeSchema,
  ),
  port_costs_by_port_and_vessel_name: z.array(
    portCostsByPortAndVesselNameSchema,
  ),
  port_data: z.array(portDataSchema),
  port_notice: z.array(portNoticeSchema),
  scheduled_order: z.array(scheduledOrderSchema),
  ship_voyage_naming_rule_relation: z.array(shipVoyageNamingRuleRelationSchema),
  shipment: z.array(shipmentSchema),
  shipment_external_status: z.array(shipmentExternalStatusSchema),
  shipment_extra_freight: z.array(shipmentExtraFreightSchema),
  shipment_freight: z.array(shipmentFreightSchema),
  ships: z.array(shipsSchema),
  single_event: z.array(singleEventSchema),
  single_event_port_call_relation: z.array(singleEventPortCallRelationSchema),
  statement_of_facts: z.array(statementOfFactsSchema),
  tc_contract: z.array(tcContractSchema),
  users: z.array(usersSchema),
  vessel_attributes: z.array(vesselAttributesSchema),
  vessel_attributes_associations: z.array(vesselAttributesAssociationsSchema),
  vessel_draft_datapoints: z.array(vesselDraftDatapointsSchema),
  vessel_fulfills_requirement_association: z.array(
    vesselFulfillsRequirementAssociationSchema,
  ),
  vessel_info: z.array(vesselInfoSchema),
  vessel_speed_consumption: z.array(vesselSpeedConsumptionSchema),
  voyage_charter: z.array(voyageCharterSchema),
  voyage_charter_extra_cost: z.array(voyageCharterExtraCostSchema),
  voyage_charter_extra_freight: z.array(voyageCharterExtraFreightSchema),
  voyage_charter_order_freight: z.array(voyageCharterOrderFreightSchema),
  voyage_charter_port_data: z.array(voyageCharterPortDataSchema),
  voyage_charter_to_contract: z.array(voyageCharterToContractSchema),
  voyage_naming_rule: z.array(voyageNamingRuleSchema),
  zone_location: z.array(zoneLocationSchema),
  zones: z.array(zonesSchema),
});
